import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-time-out',
  templateUrl: './wait-time-out.component.html',
  styleUrls: ['./wait-time-out.component.css']
})
export class WaitTimeOutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
